// SPDX-License-Identifier: SEE LICENSE
//
// Live session list: initial fetch + global SSE feed so new sessions and
// status changes appear on the list view without manual refresh.

import { useEffect, useRef, useState } from 'react';

import { listSessions, sessionsStreamUrl } from '../api';
import type { DemoEvent, SessionListItem } from './types';

export function useSessionsStream(): {
  sessions: SessionListItem[];
  connected: boolean;
  refresh: () => void;
} {
  const [sessions, setSessions] = useState<SessionListItem[]>([]);
  const [connected, setConnected] = useState(false);
  const esRef = useRef<EventSource | null>(null);

  const refresh = () => {
    listSessions()
      .then((r) => setSessions(r.sessions ?? []))
      .catch(() => {
        /* keep prior list */
      });
  };

  useEffect(() => {
    refresh();
    const es = new EventSource(sessionsStreamUrl());
    esRef.current = es;
    es.onopen = () => setConnected(true);
    es.onerror = () => setConnected(false);
    es.onmessage = (ev) => {
      let evt: DemoEvent;
      try {
        evt = JSON.parse(ev.data);
      } catch {
        return;
      }
      // Any session lifecycle change → refresh the list summary.
      if (evt.type === 'session.update' || evt.type === 'certificate.minted') {
        refresh();
      }
    };
    return () => {
      es.close();
      esRef.current = null;
    };
  }, []);

  return { sessions, connected, refresh };
}
